import { useFormContext } from 'react-hook-form-mui';
import { FormControlLabel } from '@mui/material';
import * as S from './styled';

interface CustomRadioGroupProps {
  name: string;
  label: string;
  options: { value: string; label: string }[] | any;
  styleLabel?: any;
  style?: any;
}

const RadioGroup = ({ name, label, options, styleLabel, style }: CustomRadioGroupProps) => {
  const { watch, setValue } = useFormContext();
  const selectedValue = watch(name) ?? '';

  return (
    <S.RadioGroupWrapper style={style}>
      <S.RadioGroupLabel style={styleLabel}>{label}</S.RadioGroupLabel>
      <S.CustomRadioGroup
        value={selectedValue}
        onChange={(e) => {
          return setValue(name, e.target.value);
        }}
      >
        {options.map((option) => {
          return (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<S.CustomRadio />}
              label={option.label}
            />
          );
        })}
      </S.CustomRadioGroup>
    </S.RadioGroupWrapper>
  );
};

export default RadioGroup;
